import React, {FC, useContext, useMemo} from "react"
import Typography from "../../reusable/Typography/Typography"
import FilterDropdown from "../dropdown/FilterDropdown"
import SelectedFilters from "../SelectedFilters/SelectedFilters"
import {useTranslation} from "next-i18next"
import {CollectionName} from "../../../constants"
import {CollectionViewSelector} from "../../collection"
import ProductSort from "../ProductSort"
import LayoutContext from "../../../context/LayoutContext"
import {getActiveFilters} from "../utility"
import {useRouter} from "next/router"
import VerticalSectionPlanFilters from "../../reusable/VerticalSectionPlanFilters"
import PreviousFilters from "../desktopComponents/PreviousFilters"

type Props = {
	productsPriceRange: any
	filters: any[],
	collectionName: CollectionName
	closeModal: () => void,
	overflow?: string
	customUrlBaseValue?: string
}

const FilterModalContentMobile: FC<Props> = ({
	closeModal,
	filters,
	collectionName,
	productsPriceRange,
	overflow = "auto",
	customUrlBaseValue
}): React.ReactElement => {
	const {t} = useTranslation(["common", "filters"])
	const {isMobile} = useContext(LayoutContext)
	const router = useRouter()
	const params = router.query
	const activeFilters = useMemo(() => getActiveFilters(params), [params])

	return (
		<div className={"position-fixed vh-100 vw-100 "}
			style={{
				backgroundColor: "#0000000",
				zIndex: 99999999,
				top: 0,
				left: 0
			}}
			onClick={
				closeModal
			}>
			<div className={"container-fluid  filter-modal"}
				style={{overflowY: "scroll"}}>
				<div className={"row"}>
					<div
						className={`bg-white position-fixed bottom-0 w-100 ${activeFilters.length > 0 && "pb-5"} `}
						style={{top: "18.1%", overflow, borderRadius: "16px 16px 0 0"}}
						onClick={e => {
							e.stopPropagation()
						}}>
						<div className={`bg-white ${activeFilters.length > 0 && "pb-5"} `}>
							<div className={`container px-3 ${activeFilters.length > 0 && "pb-5"} `}>
								<div className={"row pb-3"}>
									<div className="col-12 p-0 mb-4 pt-4 col-md-3">
										<div className="position-relative">
											<div className="d-none d-md-block">
												<SelectedFilters />
											</div>
											<Typography variant="bodyLgBlack"
												style={{fontSize: 20}}>{t("filters")}</Typography>
											<span style={{top: 0, right: 0, cursor: "pointer"}}
												className="position-absolute cursor-pointer"
												onClick={closeModal}>
												<img src="/assets/icons/close-icon.svg"
													alt="close" />
											</span>
										</div>
									</div>
									<PreviousFilters collectionName={collectionName}
										customUrlBaseValue={customUrlBaseValue} />

									<VerticalSectionPlanFilters collectionName={collectionName}
										productsPriceRange={productsPriceRange}
										customUrlBaseValue={customUrlBaseValue} />
									<div className="border-top col-12 px-0 mt-3 pt-3">
										<CollectionViewSelector />
									</div>
									<ProductSort customUrlBaseValue={customUrlBaseValue}
										collectionName={collectionName} />
									{filters.map(attribute =>
										<div key={attribute.id}
											className={`px-0 col-12 col-md-3 ${!isMobile && "border-bottom"}`}>
											<FilterDropdown isBoxShape={attribute.name === "availability"}
												customUrlBaseValue={customUrlBaseValue}
												collectionName={collectionName}
												label={attribute.name}
												param={attribute.slug}
												options={attribute.terms || attribute.options} />
										</div>
									)}
								</div>

							</div>
						</div>
						{activeFilters.length > 0 ?
							<div className="row col-12 px-3 position-fixed bottom-0 bg-white pb-4 gx-2 px-auto align-items-center mt-4 shadow-lg"
								style={{zIndex: 10, left: 0}}>
								<div className="col-12">
									<button className="btn col-12 text-white text-bold text-uppercase p-2"
										style={{backgroundColor: "#212529", fontSize: 14}}
										type="button"
										onClick={closeModal}>{t("see-results", {ns: "filters"})}</button>
								</div>
								<div className="col-12"> <SelectedFilters />
								</div>
							</div> : null
						}
					</div>
				</div>
			</div>
		</div>
	)
}

export default FilterModalContentMobile
